import { getOdinData } from '@/request/odinRequest';
import getAsspAd from '@/components/adver/index';
import { articleAdConfig } from '@/config/adConfig';

var LeftBottomBaiduAd = async function(opts) {
    const { spmCCode, resourceId, el, posCode, rule, fixArray } = articleAdConfig.leftFix
    const param = {
        adInfo: {
            posCode,
            rule,
            fixArray
        },
        spmCCode,
        resourceId,
        isSingleAd: true,
    }
    try {
        const data = await getOdinData(param)
        const adData = data?.list?.[0]?.resourceData
        getAsspAd({
            data: adData,
            el: document.querySelector(el),
            spmCode: `${spmCCode}.1`,
            resourceId: resourceId,
        })
    } catch (error) {
        console.log('左侧悬浮广告渲染失败', error)
    }
}

export default LeftBottomBaiduAd